import UserListComponent from "../components/UserList";
import useUserList from "../hooks/useUserList";

function UserList() {
  const useUserListProps = useUserList();
  return <UserListComponent {...useUserListProps} />;
}

export default UserList;
